import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@ajat/design-system/Button';
import './ErrorPage.css';

/* ══════════════════════════════════════════════════════════════════════════
 * Shared Error Page layout (404 / 500) — all brands
 * Brand wrappers ({Brand}/ErrorPages/) pass Header/Footer + localized copy.
 * ══════════════════════════════════════════════════════════════════════════ */

const ErrorPage = ({
  Header,
  Footer,
  brandAttr = 'CLS',
  code,
  title,
  description,
  primaryCta,
  secondaryCta,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const prev = document.documentElement.getAttribute('data-brand');
    document.documentElement.setAttribute('data-brand', brandAttr);
    return () => {
      if (prev) document.documentElement.setAttribute('data-brand', prev);
      else document.documentElement.removeAttribute('data-brand');
    };
  }, [brandAttr]);

  const handleCta = (cta) => {
    if (cta.onClick) cta.onClick();
    else if (cta.to) navigate(cta.to);
  };

  return (
    <div className="error-page">
      <Header />
      <main className="error-page__main">
        <div className="error-page__code typo-h1-editorial" aria-hidden="true">{code}</div>
        <h1 className="error-page__title typo-h2">{title}</h1>
        <p className="error-page__text typo-body">{description}</p>
        <div className="error-page__ctas">
          {primaryCta && (
            <Button
              size="secondary"
              variant="main"
              iconRight={primaryCta.icon}
              onClick={() => handleCta(primaryCta)}
            >
              {primaryCta.label}
            </Button>
          )}
          {secondaryCta && (
            <Button
              size="secondary"
              variant="outline"
              iconRight={secondaryCta.icon}
              onClick={() => handleCta(secondaryCta)}
            >
              {secondaryCta.label}
            </Button>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ErrorPage;
